module.exports = __webpack_public_path__ + "img/dating_style.63a64c03.svg";